import { ApiResponse } from 'apisauce';

import { ExportJobCreateResult } from '@/Modules/MyFilesModule/shared/types/export-job.type';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { ResponseModel } from '@/shared/interfaces/response-model.interface';
import errorHelper from '@/shared/services/helpers/error-helper/error-helper.service';

export interface AttendanceExportQueueResponse {
  success?: boolean;
  data?: ExportJobCreateResult;
  message?: string;
}

export function mapQueueExportApiResponse(
  response: ApiResponse<ResponseModel<ExportJobCreateResult>, ErrorInfo>,
  containerName: string,
  methodName: string
): ExportJobCreateResult | ErrorInfo | undefined {
  if (response.ok) {
    return response.data?.data;
  }

  return errorHelper(
    Number(response.status),
    response.data?.errorCode ? String(response.data.errorCode) : response.problem,
    containerName,
    methodName
  );
}

export function mapAttendanceQueueExportApiResponse(
  response: ApiResponse<AttendanceExportQueueResponse, ErrorInfo>,
  containerName: string,
  methodName: string
): ExportJobCreateResult | ErrorInfo | undefined {
  if (response.ok && response.data?.data?.id) {
    return response.data.data;
  }

  if (response.ok) {
    return errorHelper(0, 'Export job creation returned no job id', containerName, methodName);
  }

  const errorPayload = response.data as ErrorInfo | AttendanceExportQueueResponse | undefined;

  return errorHelper(
    Number(response.status),
    errorPayload && 'errorCode' in errorPayload && errorPayload.errorCode
      ? String(errorPayload.errorCode)
      : response.problem,
    containerName,
    methodName
  );
}

export const FIXTURE_EXPORT_JOB: ExportJobCreateResult = {
  id: 'fixture-export-job-id',
  status: 'queued',
  queuePosition: 1
};
